<template>
    <form-row title="Is any Portion Refundable?" :no_border="true" class="mt-6">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="option_fee_refundable"
                v-model="option_fee_refundable"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>

        <div v-if="option_fee_refundable" class="flex mt-4 items-center">
            <div class="flex-none sm:w-36 my-2">
                <div v-show="option_fee_refundable_by_percent">
                    <input-money
                        :value="option_fee_refundable_by_percent"
                        tabindex="-1"
                        :read_only="true"
                    />
                </div>

                <div v-show="! option_fee_refundable_by_percent">
                    <input-money
                        v-model="option_fee_refundable_entered"
                        :read_only="read_only"
                    />
                </div>

                <input
                    name="option_fee_refundable_amount"
                    type="hidden"
                    :value="option_fee_refundable_amount"
                    :read_only="true"
                />
            </div>

            <div class="flex flex-1 items-center my-2">
                <span class="text-sm text-gray-600 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="w-1/4 sm:w-1/5">
                    <input-percent
                        name="option_fee_refundable_percent"
                        v-model="option_fee_refundable_percent"
                        :read_only="read_only"
                    />
                </div>

                <span class="text-sm text-gray-600 leading-snug pl-4">
                    {{ $t('of') }} {{ option_fee_formatted }} <br>{{ $t('total option fee') }}
                </span>
            </div>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
        option_fee_amount: {},
    },

    data() {
        return {
            option_fee_refundable: this.commercial.option_fee_refundable,
            option_fee_refundable_percent:
                this.commercial.option_fee_refundable_percent,
            option_fee_refundable_entered:
                this.commercial.option_fee_refundable_amount,
        }
    },

    computed: {
        option_fee() {
            return this.formatMoney(this.option_fee_amount);
        },
        option_fee_refundable_by_percent() {
            return this.option_fee_refundable_percent
                ? this.formatMoney((this.option_fee_refundable_percent / 100) * this.moneyVal(this.option_fee))
                : null;
        },
        option_fee_refundable_amount() {
            return this.option_fee_refundable_by_percent || this.option_fee_refundable_entered;
        },
        option_fee_formatted() {
            return this.option_fee && ! isNaN(this.option_fee)
                ? '$' + this.formatMoneyToString(this.option_fee)
                : '';
        },
    },
}
</script>
